import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import CreateView from "views/common/create";
import CountryForm from "./countryForm";
import CountryCreateViewModel from "viewModels/timeCharges/distributorEnums/countries/countryCreateViewModel";

const CountryCreateView: ViewComponent<CountryCreateViewModel> = observer(({ vm }) => {
  return <CreateView vm={vm} form={<CountryForm vm={vm} />} />;
});

registerView(CountryCreateView, CountryCreateViewModel);
